// AI Generated Component
import { Component, Input, OnInit, OnChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UserRepoService } from '@client/app/services/api/user-repo/user-repo.service';
import { LabelRepo } from '@monsido/modules/endpoints/api/label.repo';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormUserComponent } from '@client/app/forms/user/user.component';
import { activeFeatures } from '@monsido/core/constants/general.constant';

@Component({
    selector: 'admin-users-table',
    templateUrl: './table.component.html',
    standalone: false,
})
export class UsersTableComponent implements OnInit, OnChanges {
    @Input() isAdmin?: boolean = false;
    @Input() users: any = [];
    @Input() currentSort?: any = { by: '', direction: '' };
    @Output() onPageSort = new EventEmitter<any>();
    @Output() getPage = new EventEmitter<any>();

    extendedUsers: any = [];
    showLabels: boolean = activeFeatures.labels;
    allLabels: any = [];
    deleteDialog: any;

    constructor (
        private userRepoService: UserRepoService,
        private labelRepo: LabelRepo,
        private loadingService: MonLoadingService,
        private monEventService: MonEventService,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnChanges (changes: any): void {
        if (changes.users) {
            this.extendedUsers = this.users.map((user: any) => {
                return Object.assign(user, {
                    avatarInitials: user.getAvatarInitials(),
                });
            });
        }
    }

    activate (): void {
        this.isAdmin = this.isAdmin || false;
        this.users = [];
        this.currentSort = this.currentSort || {
            by: '',
            direction: '',
        };
        this.getLabels();
    }

    getLabels (): void {
        this.labelRepo.getLabels().then((data: any) => {
            this.allLabels = data;
            this.cdRef.detectChanges();
        });
    }

    editUser (user?: any): void {
        user = user || {};
        let customer_admin: any;
        if (user.id) {
            customer_admin = user.customer_admin;
        }
        const params = { body: FormUserComponent, size: 'md', data: { user: user } };
        const callback = (userResult: any) => {
            if (userResult) {
                if (customer_admin !== undefined && userResult.customer_admin !== customer_admin) {
                    // behaviorService.userChangeAdmin(userResult.email, userResult.customer_admin);
                }
                this.getPage.emit();
            }
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    onConfirmDelete (input: any, user: any): void {
        if ('delete' !== input.toLowerCase()) {
            return;
        }

        this.loadingService.show();
        this.userRepoService
            .destroy(user)
            .then(() => {
                this.getPage.emit();
            })
            .finally(() => {
                this.loadingService.hide();
            });
    }

    updateUser (user: any): void {
        const params: any = {};
        params.first_name = user.first_name;
        params.email = user.email;
        params.labels = user.labels.map((label: any) => {
            return label.id;
        });
        params.id = user.id;

        this.userRepoService.update(params);
    }

    handlePageSort (event: any): void {
        if (this.currentSort.by === event.by && this.currentSort.direction === event.direction) {
            return;
        }
        this.onPageSort.emit(event);
    }
}
